/**
 * Project Calendar Page
 * Displays project events and deadlines in a calendar view using the unified Calendar component.
 */

import { useParams } from 'react-router';
import { useApp } from '../providers/AppProvider';
import Calendar from './Calendar';

export default function ProjectCalendarPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const { state } = useApp();

  const project = state?.projects?.find(
    (p) => String(p.id).toLowerCase() === String(projectId).toLowerCase()
  );

  if (!project) {
    return (
      <div className="p-4 text-center text-muted-foreground">
        Project not found
      </div>
    );
  }

  return (
    <Calendar
      projectScopeId={String(project.id)}
      projectScopeName={project.name}
    />
  );
}
